<template>
  <div class="mt-5">
    <div v-if="isLoading">
      <v-skeleton-loader
        v-for="i in 5"
        :key="i"
        type="list-item-three-line"
        class="my-2"
      />
    </div>
    <div v-else>
      <div v-if="isNotEmpty">
        <ConversationListItem
          v-for="conversation in conversations"
          :conversation="conversation"
          :key="conversation.id"
          showParticipants
          :category="category"
        />
        <v-pagination
          :total-visible="page.pageSize"
          v-model="page.currentPage"
          @input="loadConversations"
          :length="page.lastPage"
        />
      </div>
      <EmptyStates
        v-else
        icon="conversations-empty-state"
        :description="emptyStateDescription"
        :isFiltered="isFiltered"
      />
    </div>
    <ListTypeSelection
      class="mt-6"
      :text="listTypeSelectionText"
      @selectListType="changeListType"
    >
      <template v-slot:icon>
        <v-icon color="primary" class="ml-2">
          {{ `mdi-chevron-${isOpen ? "down" : "up"}` }}
        </v-icon>
      </template>
    </ListTypeSelection>
  </div>
</template>

<script>
import ListTypeSelection from "@/components/common/ListTypeSelection";
import ConversationListItem from "@/views/conversations/components/ConversationListItem";
import { size } from "lodash";
import { createNamespacedHelpers } from "vuex";
import { CONVERSATIONS_NAMESPACE } from "@/store/modules/conversations";
import { FETCH_CONVERSATIONS } from "@/store/modules/conversations/actions";
import EmptyStates from "@/components/common/EmptyStates";
import { paginationMixin } from "@/mixins/pagination.mixin";

const { mapActions } = createNamespacedHelpers(CONVERSATIONS_NAMESPACE);

export default {
  title: "Conversations - Track",
  name: "Conversations",
  mixins: [paginationMixin],
  components: {
    ListTypeSelection,
    ConversationListItem,
    EmptyStates
  },
  props: {
    search: String,
    isBookingConversation: Boolean,
    category: {
      type: String,
      reuqired: true
    }
  },
  data() {
    return {
      isOpen: true,
      conversations: [],
      isLoading: false
    };
  },
  created() {
    this.loadConversations();
  },
  computed: {
    listTypeSelectionText() {
      return `${this.timeActionName} Closed Conversations`;
    },
    timeActionName() {
      return this.isOpen ? "Show" : "Hide";
    },
    requestParams() {
      return {
        filter: {
          ...(this.isOpen && { is_open: true }),
          ...(size(this.search) && { search: this.search }),
          ...(this.isBookingConversation && { booking_id: this.bookingId }),
          category: this.category
        },
        ...this.requestPageParams
      };
    },
    bookingId() {
      return this.$route.params.id;
    },
    isNotEmpty() {
      return size(this.conversations);
    },
    isFiltered() {
      return Boolean(size(this.search));
    },
    emptyStateDescription() {
      return this.isFiltered
        ? "No conversations match your search criteria"
        : "No conversations have been started yet";
    }
  },
  methods: {
    ...mapActions({
      fetchConversations: FETCH_CONVERSATIONS
    }),
    async loadConversations() {
      this.isLoading = true;
      const data = await this.fetchConversations(this.requestParams);
      this.isLoading = false;
      if (data) {
        this.conversations = data.data;
        this.updatePageDetails(data.meta);
      }
    },
    onSearch() {
      this.resetPagination();
      this.loadConversations();
    },
    changeListType() {
      this.isOpen = !this.isOpen;
      this.resetPagination();
      this.loadConversations();
    }
  },
  watch: {
    search() {
      this.onSearch();
    }
  }
};
</script>

<style lang="scss"></style>
